import React from "react";
import DesignAfter1mage from "assets/desktop-research/svgs/design-after-large.svg";
import HeroImage from "assets/desktop-research/images/hero-image.png";
import CheckImage from "assets/desktop-research/svgs/check.svg";
import Frame3Image from "assets/desktop-research/svgs/frame3.svg";
import DesignAfter2mage from "assets/desktop-research/svgs/design-after.svg";
import ExploreImage from "assets/desktop-research/svgs/explore-outline-rounded.svg";
import ResearchApproachBg1mage from "assets/desktop-research/images/research-approach-bg.png";
import SideDesignImage from "assets/desktop-research/svgs/side-design.svg";
import ResearchImage from "assets/desktop-research/images/research-image.png";
import Hero2Image from "assets/desktop-research/images/hero2.png";
import { useTranslation } from "react-i18next";
import {
  exploresEn,
  exploresFr,
  research_approachEn,
  research_approachFr,
} from "./utils";

const ResearchExplore = () => {
  const { t } = useTranslation("event");

  const language = localStorage.getItem("selectedLanguage");

  const explores = language?.includes("fr") ? exploresFr : exploresEn;

  const research_approach = language?.includes("fr")
    ? research_approachFr
    : research_approachEn;
  return (
    <div className="flex justify-center items-center mt-[13rem] relative mb-[5rem]">
      <div className="flex justify-center items-center flex-col w-[90%] xl:w-[92%]">
        <div className="flex justify-left items-center gap-3">
          <h1 className="text-[#334155] text-[30px] xl:text-[48px] font-euclidSemibold font-euclid !w-full text-center md:text-left">
            {t("desktopResearch.researchExplore.title")}
          </h1>
          <img
            src={DesignAfter1mage}
            alt="DesignAfter1mage"
            className="hidden lg:block w-[800px] h-[10px]"
          />
        </div>
        <div className="flex justify-between items-start flex-col lg:flex-row gap-10 mt-[3rem]">
          <div className="lg:w-[60%] space-y-3">
            <p className="text-[#334155] text-lg font-euclidRegular w-[90%]">
              {t("desktopResearch.researchExplore.desc1")}
            </p>
            <div className="space-y-3">
              {explores.map((option, index) => (
                <div key={index} className="flex items-start gap-3">
                  <img
                    src={CheckImage}
                    alt="CheckImage"
                    className="w-[24px] md:w-[32px] h-[24px] md:h-[30px] mt-1.5 md:mt-0"
                  />
                  <p className="text-[#334155] text-lg font-euclidRegular">
                    {option}
                  </p>
                </div>
              ))}
            </div>
            <p className="text-[#334155] text-base font-euclidRegular md:w-[80%]">
              {t("desktopResearch.researchExplore.desc2")}{" "}
              <span className="font-semibold">
                {t("desktopResearch.researchExplore.desc3")}
              </span>
              {t("desktopResearch.researchExplore.desc4")}
            </p>
          </div>

          <div className="relative">
            <img
              src={HeroImage}
              alt="HeroImage"
              className="w-[332px] h-[413px]"
            />
            <img
              src={ExploreImage}
              alt="ExploreImage"
              className="w-[40px] h-[40px] absolute top-0 right-[-5%]"
            />
            <img
              src={Frame3Image}
              alt="Frame3Image"
              className="w-[97px] h-[44px] absolute bottom-[-10%] right-[35%]"
            />
          </div>
        </div>

        <div
          className="xl:w-[1203px] md:h-[630px] overflow-hidden  bg-cover bg-center relative flex justify-center items-center mt-[10rem] pt-[10rem] pb-20 md:py-0"
          style={{ backgroundImage: `url(${ResearchApproachBg1mage})` }}
        >
          <div className="flex justify-center items-center flex-col gap-4 w-full">
            <div className="flex justify-center items-center gap-2 w-full">
              <div className="flex justify-center items-center">
                <img
                  src={DesignAfter2mage}
                  alt="DesignAfter1mage"
                  className="hidden md:block w-[284px] h-[10px]"
                />
                <img
                  src={DesignAfter2mage}
                  alt="DesignAfter1mage"
                  className="hidden lg:block w-[284px] h-[10px]"
                />
              </div>
              <h1 className="text-white text-[30px] xl:text-[48px] font-euclidSemibold text-center">
                {t("desktopResearch.researchApproach.title")}
              </h1>
            </div>
            <div className="flex justify-between items-center flex-col-reverse xl:flex-row px-[1rem] md:px-[3rem] w-full">
              <div className="hidden xl:flex items-center gap-3 w-[40%] ml-[2rem]">
                <img src={SideDesignImage} alt="SideDesignImage" />
                <div className="relative">
                  <img
                    src={ResearchImage}
                    alt="ResearchImage"
                    className="w-[201px] h-[250px]"
                  />{" "}
                  <img
                    src={Hero2Image}
                    alt="Hero2Image"
                    className="w-[175px] h-[217px] absolute top-[3.5rem] right-[-40%]"
                  />
                  <img
                    src={ExploreImage}
                    alt="ExploreImage"
                    className="w-[30px] h-[30px] absolute top-[16%] right-[-10%]"
                  />
                </div>
              </div>
              <div className="xl:w-[60%] space-y-3 text-white">
                <p className="text-white text-lg font-euclidRegular xl:w-[90%]">
                  {t("desktopResearch.researchApproach.desc1")}
                </p>
                <p className="text-white text-base font-euclidRegular w-[90%]">
                  {t("desktopResearch.researchApproach.desc2")}
                </p>
                <div className="space-y-4 mt-5">
                  {research_approach.map((option, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <img
                        src={CheckImage}
                        alt="CheckImage"
                        className="w-[25px] h-[25px] mt-2"
                      />
                      <p className="text-lg font-euclidRegular">{option}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResearchExplore;
